import http from "./http-common";

class SequenceDataService {
  // Used in :
  //SequenceActivityListSelection -> dbGetAllSequences()
  //SequenceList -> dbGetAllSequences()
  getAll(params) {
    return http.get("/sequence", { params });
  }

  create(data) {
    return http.post("/sequence", data);
  }

  update(id, data) {
    return http.put(`/sequence/${id}`, data);
  }

  delete(id) {
    return http.delete(`/sequence/${id}`);
  }

  getEdit(id) {
    return http.get(`/sequence/${id}`);
  }

  getEditWithXml(id) {
    return http.get(`/sequence/xml/${id}`);
  }

  // Used in :
  //statsByAcademie()
  countWithFilters(params) {
    return http.get(`/sequence/countWithFilters`, { params });
  }

  getSequencesByName(ids) {
    return http.post("/sequence/names", { ids });
  }

  getSequencesOfUser(userId) {
    return http.get(`/sequence/getSequencesOfUser/${userId}`);
  }

  getSequenceInfos(sequenceId) {
    return http.get(`/sequence/getSequenceInfos/${sequenceId}`);
  }

  removeActivity(idSeq, idAct) {
    return http.get(`/sequence/rem/${idSeq}/${idAct}`);
  }

  checkKey(id, key) {
    return http.get(`/sequence/key/${id}`, { params: { key } });
  }

  getShared(params) {
    return http.get("/sequence/shared", { params });
  }

  // Used in :
  //SequenceActivityListSelection -> dbGetAllWithGeneratedActivities()

  getAllWithGeneratedActivities(params) {
    return http.get(`/sequence/findAllWithGeneratedActivities`, { params });
  }

  // Used in :
  //Use -> downloadZip()

  /*
  zipSequenceOffline(
    currentSequence,
    structureActivities,
    isPseudoSequence,
    isScorm,
    isHTMLOnly
  ) {
    return http.post(`/zipSequenceOffline`, {
      params: {
        currentSequence,
        structureActivities,
        isPseudoSequence,
        isScorm,
        isHTMLOnly
      },
    });
  }
*/

  zipSequenceOffline(data) {
    return http.post(`/zipSequenceOffline`, data);
  }
}

export default new SequenceDataService();
